import { DestroyRef, Directive, ViewContainerRef, inject } from '@angular/core';
import { BuildingBannerSlotRegistry } from './building-banner-slot-registry';

@Directive({
    selector: 'ng-template[qpxBuildingBannerSlot]',
})
export class BuildingBannerSlot {
    //#region Dependency injection
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly registry = inject(BuildingBannerSlotRegistry);
    private readonly destroyRef = inject(DestroyRef);
    //#endregion

    //#region Lifecycle hooks
    constructor() {
        this.registry.registerSlot(this.viewContainer);

        this.destroyRef.onDestroy(() => {
            this.registry.unregisterSlot(this.viewContainer);
        });
    }
    //#endregion
}
